import { render, staticRenderFns } from "./tipNumbers.vue?vue&type=template&id=e99f99c6&scoped=true&"
import script from "./tipNumbers.vue?vue&type=script&lang=js&"
export * from "./tipNumbers.vue?vue&type=script&lang=js&"
import style0 from "./tipNumbers.vue?vue&type=style&index=0&id=e99f99c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99f99c6",
  null
  
)

export default component.exports